module.exports = __webpack_public_path__ + "static/img/default-img.2b870e34.png";